import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';

export const Container = styled.div`
&.Wrapper{
  display: flex;
  padding: 10% 0 15% 0;
}
&.LeftBlock{
  width: 35%;
}
&.RightBlock{
  width: 65%;
}
`;

export const StyledModalBtn = styled.button`
position: absolute;
top: -14px;
right: -12px;
padding: 10px;
background: #fff;
border-radius: 100%;
border-width: 0;
display: flex;
justify-content: center;
align-items: center;
background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
&:hover{
  box-shadow: none;
  border-radius: 100%;
  border-width: 0;
}
&:focus{
  border-width: 0;
  box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
  border-radius: 100%;
}
`;

export const StyledModalHeader = styled(Modal.Header)`
border-bottom: 0;
display: flex;
justify-content: flex-end;
position: relative;
padding: 30px;
`;

export const StyledH2 = styled.h2`
font-family: Manrope, sans-serif;
font-style: normal;
font-weight: 600;
font-size: 36px;
line-height: 135%;
color: #2C2B48;
`;

export const StyledParagraph = styled.p`
font-family: OpenSans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 20px;
line-height: 180%;
color: #2C2B48;
`;

export const StyledImg = styled.img`
width: 100%;
`;